import React, { ChangeEvent } from "react";
import {
  Table, Input, Row, Col, Pagination, Button, Spin, notification, Modal, 
  Popconfirm, Breadcrumb, Upload, Select, Form, Cascader, TreeSelect, 
  FormInstance, Space, Dropdown, Menu, Empty,
  DatePicker,
  InputNumber,
} from "antd";
import { connect } from "react-redux";
import Column from "antd/lib/table/Column";
import dayjs from 'dayjs';
import { RootStoreModel } from "../../redux/reducers";

import { Link, RouteComponentProps } from "react-router-dom";
// import { Columns } from "./utils";
import { ColumnModel, BasicStateForListModel } from "../models";
import { CancelTokenSource, IsCancel } from "../../axios/axios.core";
import {
  getSignPlayPlan,
  getAllSignContents,
  getSignPlayPlanList,
  deleteSignPlayPlan,
  addOrUpdateSignPlayPlan,
  moveSignPlayPlan
} from "../../axios/api.sign";
import { 
  UploadOutlined, PlusOutlined, CheckCircleFilled, StopFilled, DownOutlined, FileDoneOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  MinusOutlined
} from "@ant-design/icons";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";

import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
  isModalVisible: boolean;
  isMultiple: boolean;
  title: string;
  file: any;
  fileList: any[];
  status: "Active" | "Disabled";
  search: string;
  id: string;
  appTypeVisible: boolean,
  applyPeople: string
  tags: any[],
  selectId: string,
  maxCount: number,
  planContents: any[],
  signContentOptions: any[],
  formatDate: string,
  priority: number,
  dateRange: any[]
}

const { Item, List } = Form;
const { RangePicker } = DatePicker;

interface propsModel extends RouteComponentProps<any, any, any> {
  orgOptions: treeNode[],
}

const mapStatetoProps = (state: RootStoreModel) => ({
  orgOptions: getOrgsOptionsSelector(state),
});

class SignPlayPlanListPage extends React.Component<propsModel, stateModel> {
  formRef = React.createRef<FormInstance>();
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      isModalVisible: false,
      isMultiple: false,
      title: "",
      file: "",
      fileList: [],
      status: "Active",
      search: "",
      id: "",
      appTypeVisible: false,
      applyPeople: "",
      tags: [],
      selectId: "",
      maxCount: 9,
      planContents: [],
      signContentOptions: [],
      formatDate: "YYYY-MM-DD",
      priority: 1,
      dateRange: []
    };
  }

  cancelToken = CancelTokenSource();

  componentDidMount() {
    this.getList();
    this.getSignContents();
  }

  componentDidUpdate(prevProps: propsModel) {
  }

  componentWillUnmount() {
    this.cancelToken.cancel("cancel axios http request");
  }

  getSignContents = () => {
    getAllSignContents({}).then((res) => {
        var dat = this.formatOptions(res);
        this.setState({ signContentOptions: dat });
      })
  };

  formatOptions = (signContetns: any[]) => {
    return signContetns.map(({ id, title }) => {
      return {
        value: id,
        label: title
      };
    });
  }

  onSearch = () => {
    this.getList(1);
  };

  getList = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize
  ) => {
    const { search } = this.state;
    this.setState({ loading: true });
    getSignPlayPlanList({ pageIndex, pageSize, search }).then((res) => {
      this.setState({
        data: res.dataList,
        loading: false,
        pageSize: res.pageSize,
        pageIndex: res.pageIndex,
        totalCount: res.totalCount,
      });
    }, () => {
      this.setState({
        loading: false,
      });
    });
  };

  onRemoveInput = (id: string) => {
      var contents = this.state.planContents.filter((item) => item.id !== id);
      this.setState({planContents: contents});
  };

  onInputChange = (id: string, value: string) => {
      var newVals = this.updateObjectInArray(this.state.planContents,id,{value:value})
      this.setState({planContents: newVals});
  };

  updateObjectInArray = (arr:any, indexToUpdate:any, newValues:any) => {
      return arr.map((item:any) => 
        item.id === indexToUpdate ? {...item, ...newValues} : item
      );
  };

  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteSignPlayPlan(id).then(() => {
      notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
      this.setState({ loading: false });
      this.getList(1);
    });
  };

  onOk = () => {
    this.formRef.current?.validateFields().then((res)=>{
      if(res?.planContents.length ==0)
      {
        notification.warning({ message: <Translation>{t => {return t("请添加多媒体")}}</Translation> });
        return;
      }
      const [s1, s2] = res.dateRange;
      var startDate = s1.format(this.state.formatDate);
      var endDate = s2.format(this.state.formatDate);
      var req = {
        id: this.state.id,
        title: res.title,
        startDate: startDate,
        endDate : endDate,
        priority: res.priority,
        contents: res.planContents,
        status: res.status
      }
      console.log(req);
      this.setState({ loading: true });
      addOrUpdateSignPlayPlan(req).then(
        () => {
          notification.success({ message: <Translation>{t => {return t("提交成功")}}</Translation> });
          this.setState({ loading: false, isModalVisible: false });
          this.getList(1);
        },
        () => { this.setState({ loading: false });  }
      );
    });
  };

  onEdit = (item: any) => {
    const { id, title, status } = item;
    getSignPlayPlan(id).then((res)=>{
      var startDate = res.startDate;
      var endDate = res.endDate;
      var dateRange = [dayjs(startDate, this.state.formatDate), dayjs(endDate, this.state.formatDate)];
      console.log(dateRange);
      this.setState({
        planContents: res.contents,
        isModalVisible: true,
        id: res.id,
        title: res.title,
        status: res.status,
        priority: res.priority,
        dateRange: dateRange
      });
    });
  };

  onCancel = () => {
    this.setState({
      isModalVisible: false,
      id: "",
      title: "",
      status: "Active",
      priority: 1,
      dateRange: [],
      planContents: []
    });
    
    this.formRef.current?.resetFields();
  };

  moveItem = (in1: number,in2:number) => {
    console.log(in1,in2);
    var item1 = this.state.data[in1];
    var item2 = this.state.data[in2];
    var req = [item1?.id, item2.id];

    moveSignPlayPlan({ planIds: req }).then(() => {
      this.getList(1);
    });
  };

  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      isModalVisible,
      title,
      status,
      search,
      id,
      signContentOptions,
      planContents,
      dateRange,
      priority
    } = this.state;
    const { orgOptions } = this.props;
    return (
      <Translation>{t => {
        return (
          <div>
            <div className="breadcrumbTop py-2">
              <Breadcrumb>
                <Breadcrumb.Item>{t("标牌内容")}</Breadcrumb.Item>
                <Breadcrumb.Item>{t("播放计划")}</Breadcrumb.Item>
              </Breadcrumb>
              <Row style={{padding: "32px 0 11px 0"}}>
                  <Space>
                      <img src="/images/contentdocumentIcon.svg" alt="" />
                      <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("播放计划")}</span>
                  </Space>
              </Row>
            </div>

            <Spin spinning={false}>
              <Row style={{ width: "100%" }}>
                <div className="borderBox">
                  <Row style={{marginBottom: 8}}>
                    <Col className="ms-auto">
                      <Space>
                        <Button type="primary" onClick={() => { this.setState({ isModalVisible: true }); }}><PlusOutlined />{t("添加计划")}</Button>
                      </Space>
                    </Col>
                  </Row>
                  <Table
                    size="middle"
                    loading={loading}
                    dataSource={data}
                    onChange={(pagination) => { }}
                    rowKey={record => record.id}
                    locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                  >
                    <Column 
                      key="title" 
                      dataIndex="title" 
                      title={t("播放计划标题")}
                      render={(v) => {
                        return (<>
                          <Space className="space-width-auto">
                            <FileDoneOutlined style={{display: "block"}}/>
                            <span>{v}</span>
                          </Space>
                        </>)
                      }}
                    ></Column>
                    <Column
                      key="startDate"
                      dataIndex="startDate"
                      title={t("开始时间")}
                    ></Column>
                    <Column
                      key="endDate"
                      dataIndex="endDate"
                      title={t("结束时间")}
                    ></Column>
                    <Column
                      key="status"
                      dataIndex="status"
                      title={t("状态")}
                      render={(v) => (
                        <> 
                          {v=="Active"&&(
                            <span><CheckCircleFilled  style={{color:"#4CB8BE",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                          )}
                          {v=="Disabled"&&(
                            <span><StopFilled  style={{color:"#C9A063",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                          )}
                        </>
                      )}
                    ></Column>
                    <Column
                      key="createdTime"
                      dataIndex="createdTime"
                      title={t("创建时间")}
                    ></Column>
                    <Column
                      key="updateTime"
                      dataIndex="updateTime"
                      title={t("最近修改时间")}
                    ></Column>
                    <Column
                      key="priority"
                      dataIndex="priority"
                      title={t("优先级")}
                    ></Column>
                    <Column
                      key="operation"
                      dataIndex="id"
                      title={t("操作")}
                      render={(v: string, d: any, index) => {
                        return (
                          <Space size={8}>
                            <Button
                              icon={<ArrowUpOutlined />}
                              disabled={index === 0}
                              onClick={() => this.moveItem(index, index - 1)}
                              style={{ marginLeft: 8 }}
                            />
                            <Button
                              icon={<ArrowDownOutlined />}
                              disabled={index === data?.length - 1}
                              onClick={() => this.moveItem(index, index + 1)}
                              style={{ marginLeft: 8 }}
                            />
                            <Button type="link" size="small" onClick={() => { this.onEdit(d); }}>
                              {t("编辑")}
                            </Button>
                            <Popconfirm
                              title={`${t("确认删除播放计划")} ${d.title}？`}
                              onConfirm={() => this.onDelete(v)}
                              okText={t("确认")}
                              cancelText={t("取消")}
                            >
                              <Button type="link" size="small">
                                {t("删除")}
                              </Button>
                            </Popconfirm>
                          </Space>
                        );
                      }}
                    ></Column>
                  </Table>
                  <Pagination
                    style={{ textAlign: "right", marginTop: "20px" }}
                    pageSize={pageSize}
                    current={pageIndex}
                    total={totalCount}
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} / ${total} ${t("条")}`
                    }
                    onChange={(page, pageSize) => {
                      this.getList(page, pageSize);
                    }}
                    onShowSizeChange={(current, size) => this.getList(current, size)}
                  ></Pagination>
                </div>
              </Row>
            </Spin>
            <Modal
              maskClosable={false}
              title={id ? t("编辑播放计划") : t("添加播放计划")}
              destroyOnClose={true}
              confirmLoading={loading}
              open={isModalVisible}
              width={650}
              onOk={() => this.onOk()}
              onCancel={() => this.onCancel()}
              okText={t("确认")}
              cancelText={t("取消")}
            >
                <Form
                  layout="horizontal"
                  ref={this.formRef}
                  initialValues={{ 
                      planContents: planContents, 
                      status: status,
                      title: title,
                      dateRange: dateRange,
                      priority: priority
                    }
                  }
                >
                  <Form.Item
                      name="title"
                      label={t("播放计划名称")}
                      rules={[{ required: true }]}
                      labelCol={{ span: 24 }}
                  >
                    <Input autoComplete="off"></Input>
                  </Form.Item>
                  <Form.Item
                      name="dateRange"
                      label={t("生效时间")}
                      rules={[{ required: true }]}
                      labelCol={{ span: 24 }}
                  >
                    <RangePicker />
                  </Form.Item>
                  <Form.Item
                      name="priority"
                      label={t("播放优先级")}
                      rules={[{ required: true }]}
                      labelCol={{ span: 24 }}
                  >
                    <InputNumber autoComplete="off"></InputNumber>
                  </Form.Item>
                  <Row style={{ paddingTop: '10px', paddingBottom:'15px'}}>
                    <Col span={4}>
                      <label htmlFor=""><span style={{color: '#ff4d4f', fontSize: '14px', lineHeight: 1, fontFamily: 'SimSun, sans-serif'}}>*</span>&nbsp; {t("播放内容")}</label>
                    </Col>
                  </Row>
                  <List name="planContents">
                    {(fields, { add, remove, move }) => (
                      <>
                        {fields.map(({ key, name, ...restField }, index) => (
                          <div key={key} style={{ marginBottom: 8}}>
                            <Row justify="space-between">
                              <Col span="18">
                                <Item
                                  label={t("多媒体")}
                                  name={[name, 'signContentId']}
                                  rules={[{ required: true, message: '请选择多媒体' }]}
                                >
                                  <Select options={signContentOptions} 
                                    placeholder={t("请选择")} 
                                    showSearch
                                    onSearch={value => console.log(value)}
                                    filterOption={(input, option) =>
                                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                  />
                                </Item>
                              </Col>
                              <Col>
                                <Button
                                  icon={<MinusOutlined />}
                                  onClick={() => { remove(name); }}
                                  style={{ marginLeft: 8 }}
                                />
                                <Button
                                  icon={<ArrowUpOutlined />}
                                  disabled={index === 0}
                                  onClick={() => move(index, index - 1)}
                                  style={{ marginLeft: 8 }}
                                />
                                <Button
                                  icon={<ArrowDownOutlined />}
                                  disabled={index === fields.length - 1}
                                  onClick={() => move(index, index + 1)}
                                  style={{ marginLeft: 8 }}
                                />
                              </Col>
                            </Row>
                          </div>
                        ))}
                        <Form.Item>
                          <Button type="dashed" onClick={() => { add(); }} block>
                            {t("添加多媒体")}
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </List>
                  <Form.Item
                      name="status"
                      label={t("状态")}
                      rules={[{ required: true }]}
                      labelCol={{ span: 24 }}
                  >
                    <Select>
                      <Select.Option value="Active"> {t("正常")}</Select.Option>
                      <Select.Option value="Disabled"> {t("禁用")}</Select.Option>
                    </Select>
                  </Form.Item>
                </Form>
            </Modal>
           
          </div>
        )
      }}</Translation>
    );
  }
}

export default connect(mapStatetoProps, {})(SignPlayPlanListPage);
